import _ from 'lodash';

//********************** EPG **********************
// Epg item positions
export const calculateItemWidth = ({ timeSince, timeTill, epgItemWidth }) => {
	let diff = (timeSince - timeTill) / 1000;
	diff /= 60;
	const time = Math.abs(Math.round(diff));
	const width = (time * epgItemWidth) / 60;

	return width;
};

export const calculateWidth = (program, epgItemWidth, date) => {
	// Get program since, till time
	let timeSince = new Date(program.since.replace(/-/g, '/')).getTime();
	let timeTill = new Date(program.till.replace(/-/g, '/')).getTime();
	// Get today and tomorrow time
	const tomorrow = new Date(date.till).getTime();
	const today = new Date(date.since).getTime();
	// Check if today is grater than program's since time
	// Check if tomorrow is grater than program's till time
	if (timeSince < today && timeTill < tomorrow) {
		timeSince = today;
	} else if (timeTill > tomorrow && timeSince > today) {
		timeTill = tomorrow;
	}
	// Calculate program width
	return calculateItemWidth({
		timeSince,
		timeTill,
		epgItemWidth
	});
};

export const getProgramTimes = (epgs, program, index, date) => {
	const today = new Date(date.since).getTime();
	const tomorrow = new Date(date.till).getTime();
	let timeTill = new Date(epgs[index - 1].till.replace(/-/g, '/')).getTime();
	let timeSince = new Date(program.since.replace(/-/g, '/')).getTime();

	if (timeTill < today) {
		timeTill = today;
	} else if (timeSince > tomorrow) {
		timeSince = tomorrow;
	} else if (timeSince < today) {
		timeSince = today;
	}

	return { timeTill, today, timeSince, tomorrow };
};

export const calculateCellPosition = ({
	index,
	epgWidth,
	y,
	width,
	height,
	newChannel,
	_columnX,
	_columnY,
	lackWidth,
	isLackWidth,
	isBlackout,
	isLastProgram
}) => {
	let x;
	if (index === 0) {
		newChannel = false;
		x = 0;
		_columnX = width;
		y = 0;
	}
	// else if (isBlackOut) {
	// 	x = 0;
	// 	newChannel = true;
	// 	_columnX = width;
	// 	y += height;
	// 	_columnY += height;
	// }
	else if (_columnX < epgWidth) {
		if (isLackWidth) {
			x = _columnX - lackWidth;
		} else {
			x = _columnX + lackWidth;
		}

		newChannel = false;
		_columnX = x + width;
		lackWidth = 0;
	} else if (isLastProgram && _columnX >= epgWidth) {
		x = 0;
		newChannel = false;
		_columnX = 0;
		y += 0;
		_columnY += height;
	} else if (_columnX >= epgWidth) {
		x = 0;
		newChannel = true;
		_columnX = width;
		y += height;
		_columnY += height;
	}

	return {
		x,
		y,
		width,
		height,
		newChannel,
		_columnX,
		_columnY,
		lackWidth
	};
};

// Drag epg
export const dragEpg = ({ onMouseUp, onMouseDown }) => {
	// Drag to scroll epg
	let curDown = false;
	let curYPos = 0;
	let curXPos = 0;
	let scrollLeft = 0;
	let scrollTop = 0;

	const epg = document.querySelector('.epg');

	epg.addEventListener('mousedown', (e) => {
		e.preventDefault();
		epg.style.scrollBehavior = 'auto';
		setTimeout(() => epg.classList.add('drag-scroll'), 400);
		curDown = true;
		curYPos = e.pageY - epg.offsetTop;
		scrollTop = epg.scrollTop;
		curXPos = e.pageX - epg.offsetLeft;
		scrollLeft = epg.scrollLeft;

		if (onMouseDown) {
			onMouseDown();
		}
	});

	epg.addEventListener('mouseup', () => {
		curDown = false;
		epg.style.scrollBehavior = 'smooth';
		epg.classList.remove('drag-scroll');

		if (onMouseUp) {
			onMouseUp();
		}
	});

	epg.addEventListener('mouseleave', () => {
		curDown = false;
		epg.style.scrollBehavior = 'smooth';
		epg.classList.remove('drag-scroll');
	});

	epg.addEventListener(
		'mousemove',
		_.throttle((e) => {
			if (curDown === true) {
				e.preventDefault();
				const y = e.pageY - epg.offsetTop;
				const walkY = y - curYPos;
				const x = e.pageX - epg.offsetLeft;
				const walkX = x - curXPos;
				epg.scrollLeft = scrollLeft - walkX;
				epg.scrollTop = scrollTop - walkY;
			}
		}, 10)
	);
};
